export enum OLIntensityEnum {
    strong = 'strong',
    semi = 'semi',
    border = 'border',
    strongborder = 'strongborder'
}

export const OLIntensityMap: Record<OLIntensityEnum, { fillOpacity: number; borderOpacity?: number }> = {
    [OLIntensityEnum.strong]: { fillOpacity: 0.67 },
    [OLIntensityEnum.semi]: { fillOpacity: 0.36 },
    [OLIntensityEnum.border]: { fillOpacity: 0.01, borderOpacity: 0.67 },
    [OLIntensityEnum.strongborder]: { fillOpacity: 0.01, borderOpacity: 0.95 },
}